/**
 * @generated SignedSource<<9e8593f95b1f024dbf75273a2c172251>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EmployeeShiftStatus = "ACTIVE" | "PAST" | "UPCOMING";
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleShiftBar$data = {
  readonly durationSeconds: number;
  readonly formattedEndAtTime: string;
  readonly formattedStartAtTime: string;
  readonly scheduleType: {
    readonly color: string | null;
    readonly title: string;
  } | null;
  readonly startAtSecondsFromMidnight: number;
  readonly status: EmployeeShiftStatus;
  readonly " $fragmentType": "EmployeeScheduleShiftBar";
};
export type EmployeeScheduleShiftBar$key = {
  readonly " $data"?: EmployeeScheduleShiftBar$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftBar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleShiftBar",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedStartAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedEndAtTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationSeconds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAtSecondsFromMidnight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeScheduleType",
      "kind": "LinkedField",
      "name": "scheduleType",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeShift",
  "abstractKey": null
};

(node as any).hash = "098a70c13138030de2a4d2d72a2a9eab";

export default node;
